import type { ScanStateIndicatorProps } from "."

import { ScanStatusIcon } from "../../../../../molecules/ScanStatusTag"
import styles from "./ScanStateIndicator.module.scss"

export const ScanStateIndicator = ({
  scanState,
  children
}: ScanStateIndicatorProps) => (
  <div className={styles.container}>
    {children}
    {scanState === "Rolling" && (
      <span
        data-tooltip-content="inventory.scanState.rolling"
        data-tooltip-translation="true"
      >
        <ScanStatusIcon status="Processing" />
      </span>
    )}
  </div>
)
